import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PrintBuilder } from '../../models/builders/print.builder';
import { Material } from '../../models/material';

@Injectable()
export class PrintApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }prints`;
  }

  getPrintsByProgram(hash: string) {
    const params = new HttpParams().append('program', hash);

    return this.getFilteredPrints(params);
  }

  getPrintsByMaterial(material: Material) {
    const params = new HttpParams().append('material', material.hash);

    return this.getFilteredPrints(params);
  }

  private getFilteredPrints(params: HttpParams) {
    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(
        map(PrintBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/print-api.service.ts